import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'antd';
import WithAuth from '../../../../HOC/Auth/WithAuth';
// css-module
import styles from './Menu.module.css';
import { capitalize } from '../../../../store/utility';
// extracting custom components from Menu class
const { Item } = Menu;

// _Menu is app defined Menu
class _Menu extends Component {
  menuItems = keys => {
    if (!keys) return null;
    return keys.map(e => {
      const key = e
        .split(' ')
        .map(e => capitalize(e))
        .join('');
      return (
        <Item className={styles.Item} key={key}>
          {capitalize(e)}
        </Item>
      );
    });
  };

  render() {
    if (!this.props.isLoggedIn()) return <Menu>{null}</Menu>;

    return (
      <Menu
        onClick={this.props.onToolbarItemClick}
        selectedKeys={[this.props.current]}
        mode="horizontal"
        className={styles.Menu}
      >
        {this.menuItems(this.props.menuItems)}
      </Menu>
    );
  }
}

_Menu.propTypes = {
  current: PropTypes.string.isRequired,
  onToolbarItemClick: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.func.isRequired,
  isLoading: PropTypes.func.isRequired,
  menuItems: PropTypes.array.isRequired,
};

export default WithAuth(_Menu, 'Toolbar');



// WEBPACK FOOTER //
// ./src/containers/Navigation/Toolbar/Menu/Menu.js